'use strict';

var dsGroupElCtrl = [function() {    
    var _this=this; 
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            field: '=' ,
            elements: '='             
        },
        replace: false,
        controller: dsGroupElCtrl,
        controllerAs: 'ctrlGroup',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/dataSourceGroupElDirective.html'
    };
};
